<template>
  <div id="app">
    <Header v-if="!$route.meta.headHide"></Header>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <Footer v-if="!$route.meta.footHide"></Footer>
  </div>
</template>
<script>
import Header from './components/common/Header.vue'
import Footer from './components/common/Footer.vue'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'app',
  data() {
    return {}
  },
  computed: {
    ...mapState({
      shopMenu: state => state.shopMenu,
    }),
  },
  components: {
    Header,
    Footer,
  },
  methods: {
    ...mapActions(['getShopMenuAction']),
    setFavicon() {
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.$store.state.config.shop_logo
      document.getElementsByTagName('head')[0].appendChild(link)
    },
    getShopConfig() {
      if (this.$storage.get('config')) {
        this.$store.dispatch('getShopConfig', this.$storage.get('config'))
      } else {
        this.$api.shopConfig().then(res => {
          this.$storage.set('config', res)
          this.$store.dispatch('getShopConfig', res)
        })
      }
      this.setFavicon()
    },
    getAreaList() {
      //if (this.$storage.get('areaList')) return
      this.$api.getAreaList({}).then(res => {
        if (res.status) {
          this.$storage.set('areaList', res.data)
        }
      })
    },
  },
  created() {
    this.getShopConfig()
    this.getAreaList()
    this.getShopMenuAction()
  },
  mounted() {},
}
</script>

<style lang="scss">
@import './assets/css/index.scss';
@import './assets/css/variable.scss';
body,
html {
  min-width: 1226px;
  height: 100%;
  background: $theme-bg;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei, 'Avenir', Helvetica, Arial, sans-serif;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
}
.el-container {
  width: 100%;
}
.shop-container {
  width: 1226px;
  margin: 0 auto;
}
.error {
  font-size: 14px;
  line-height: 20px;
}
.bgw {
  background: #fff;
}
.bgc {
  background: $theme-bg;
}
.shop-container .nav-bread {
  @include line-height(40px);
  font-size: 12px;
  span {
    padding: 0 4px;
    font-size: #757575;
  }
  a:hover {
    color: #000;
  }
}
.coupon-list {
  display: flex;
  flex-flow: row wrap;
  padding: 20px 0;
}
.coupon-wrap {
  width: 300px;
  height: 100px;
  color: #fff;
  position: relative;
  margin: 10px auto;
  background: linear-gradient(to right, #ff6565, #ff8a8a);
  &:nth-child(3n + 3) {
    margin-right: 0;
  }
  &.nouse {
    background: #c3c3c3;
  }
  .content {
    flex: 1;
    height: 100px;
    position: relative;
    background: url('~@/assets/icon/semi-circle.png') no-repeat 0px center;
    .price {
      position: absolute;
      top: 15px;
      left: 20px;
      width: 80%;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      .num {
        font-size: 18px;
      }
    }
    .desc {
      position: absolute;
      top: 55px;
      left: 20px;
      font-size: 12px;
    }
    .time {
      position: absolute;
      bottom: 15px;
      left: 20px;
      font-size: 12px;
    }
  }
  .status {
    position: absolute;
    right: 8px;
    top: 0px;
    height: 100%;
    color: $theme-color;
    a {
      display: block;
      width: 20px;
      background: #ffe7e7;
      margin-top: 16px;
      text-align: center;
      padding: 10px 2px;
      font-size: 12px;
    }
    .icon {
      font-size: 50px;
      color: #fff;
    }
  }
}
</style>